module.exports = __webpack_public_path__ + "img/symbol_13_x1000.8c91ae46.png";